// reducer
export const SET_USER = "SET_USER";
export const CLEAR_USER = "CLEAR_USER";
export const LOAD_USER_ERROR = "LOAD_USER_ERROR";
export const TOGGLE_IMPERSONATING = "TOGGLE_IMPERSONATING";

// epics
export const LOAD_USER_$ = "LOAD_USER_$";
export const LOGOUT_$ = "LOGOUT_$";
